import React from "react";

import Chip from "@/components/ui/chip";
import { ApprovalRequestStatus } from "@/features/approval-flows/types/approval-flows.types";
import type { PersonnelRequestEntry } from "../types/request-and-approval.types";

interface EnrollmentApprovalStatusChipProps {
  entry: PersonnelRequestEntry;
  /** Onay talebi yoksa ya da sonuçlandıysa gösterilecek sabit durum etiketi. */
  fallbackLabel: string;
  fallbackType: "success" | "warning" | "error" | "default";
}

/**
 * Kayıt satırının durum çipi. Bekleyen dinamik onay talebi varsa akışın gerçek
 * adımını gösterir ("2/3 · Şube Müdürü Onayı"); yoksa eski status etiketine düşer.
 */
const EnrollmentApprovalStatusChip: React.FC<EnrollmentApprovalStatusChipProps> = ({
  entry,
  fallbackLabel,
  fallbackType,
}) => {
  const approval = entry.approval;
  const isPendingFlow =
    approval != null &&
    approval.status === ApprovalRequestStatus.PENDING &&
    approval.currentStepOrder !== null;

  if (isPendingFlow) {
    return (
      <Chip size="small" type="warning" variant="soft">
        {approval.currentStepOrder}/{approval.totalSteps} ·{" "}
        {approval.currentStepTitle ?? "Onay Bekliyor"}
      </Chip>
    );
  }

  return (
    <Chip size="small" type={fallbackType} variant="soft">
      {fallbackLabel}
    </Chip>
  );
};

export default EnrollmentApprovalStatusChip;
